"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalFooter,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
  ResponsiveModalTrigger,
} from "./responsive-modal";

export function ResponsiveModalContentDemo() {
  return (
    <div className="grid grid-cols-2 gap-4">
      <ResponsiveModal>
        <ResponsiveModalTrigger asChild>
          <Button variant="outline">Form Modal</Button>
        </ResponsiveModalTrigger>
        <ResponsiveModalContent>
          <ResponsiveModalHeader>
            <ResponsiveModalTitle>Contact Form</ResponsiveModalTitle>
            <ResponsiveModalDescription>
              Fill out this form to get in touch with us.
            </ResponsiveModalDescription>
          </ResponsiveModalHeader>

          <form className="space-y-4 py-4">
            <div className="grid w-full items-center gap-1.5">
              <label htmlFor="name" className="text-sm font-medium">
                Name
              </label>
              <input
                id="name"
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                placeholder="Your name"
              />
            </div>
            <div className="grid w-full items-center gap-1.5">
              <label htmlFor="email" className="text-sm font-medium">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
                placeholder="your.email@example.com"
              />
            </div>
            <div className="grid w-full items-center gap-1.5">
              <label htmlFor="message" className="text-sm font-medium">
                Message
              </label>
              <textarea
                id="message"
                className="flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm min-h-[80px]"
                placeholder="Your message..."
              />
            </div>
          </form>

          <ResponsiveModalFooter>
            <Button variant="outline" className="mr-2">
              Cancel
            </Button>
            <Button type="submit">Submit</Button>
          </ResponsiveModalFooter>
        </ResponsiveModalContent>
      </ResponsiveModal>

      <ResponsiveModal>
        <ResponsiveModalTrigger asChild>
          <Button variant="outline">Table Modal</Button>
        </ResponsiveModalTrigger>
        <ResponsiveModalContent className="max-w-2xl">
          <ResponsiveModalHeader>
            <ResponsiveModalTitle>User Data</ResponsiveModalTitle>
            <ResponsiveModalDescription>
              A modal containing a data table.
            </ResponsiveModalDescription>
          </ResponsiveModalHeader>

          <div className="py-4">
            <div className="rounded-md border">
              <table className="w-full">
                <thead>
                  <tr className="border-b bg-muted/50 text-sm">
                    <th className="px-4 py-2 text-left font-medium">ID</th>
                    <th className="px-4 py-2 text-left font-medium">Name</th>
                    <th className="px-4 py-2 text-left font-medium">Email</th>
                    <th className="px-4 py-2 text-left font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map((id) => (
                    <tr key={id} className="border-b">
                      <td className="px-4 py-2 text-sm">{id}</td>
                      <td className="px-4 py-2 text-sm">User {id}</td>
                      <td className="px-4 py-2 text-sm">
                        user{id}@example.com
                      </td>
                      <td className="px-4 py-2 text-sm">
                        <span
                          className={`inline-block px-2 py-1 text-xs rounded-full ${
                            id % 2 === 0
                              ? "bg-green-100 text-green-700"
                              : "bg-amber-100 text-amber-700"
                          }`}
                        >
                          {id % 2 === 0 ? "Active" : "Pending"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <ResponsiveModalFooter>
            <Button type="button">Export Data</Button>
          </ResponsiveModalFooter>
        </ResponsiveModalContent>
      </ResponsiveModal>
    </div>
  );
}
